<template>
	<div class="login-wrapper">
		<div class="login-form">
			<form @submit.prevent="">
				<img class="login-logo" :src="require('@/assets/logo/New_DeliveryB2B__Branco_Horizontal.png')">
				<div class="login-input-wrapper">
					<input v-model="username" class="login-input" type="text" placeholder="Usuário" :disabled="loading" @input="error_msg = ''" ref="username" />
					<i class="fa fa-fw fa-user login-input-icon"></i>
				</div>
				<div class="login-input-wrapper">
					<input v-model="password" class="login-input" :type="show_password ? 'text' : 'password'" placeholder="Senha" :disabled="loading" @input="error_msg = ''" ref="password" />
					<i class="fa fa-fw fa-key login-input-icon"></i>
					<button class="password-input-button" @click="show_password = !show_password"><i class="fa fa-fw login-input-icon" :class="show_password ? 'fa-eye' : 'fa-eye-slash'"></i></button>
				</div>
				<div class="login-forgot-password-wrapper">
					<a href="#" @click="forgotPassword"> ESQUECI MINHA SENHA</a>
				</div>
				<div class="login-error-wrapper">
					<span class="login-error" v-if="error_msg != ''"><i class="fas fa-exclamation-circle"></i> {{ error_msg }}</span>
				</div>
				<button class="login-submit" :disabled="loading" @click.prevent="loginAdmin">
					ACESSAR 
					<i v-if="!loading" class="fa fa-fw fa-angle-right"></i>
					<i v-if="loading" class="fa fa-fw fa-circle-notch fa-spin"></i>
				</button>
			</form>
		</div>
	</div>
</template>

<script>
import Api from "@/lib/Api";

export default {
	name: "LoginForm",

	data: function() {
		return {
			loading: true,
			username: "",
			password: "",
			error_msg: "",

			show_password: false,
		}
	},

	mounted: function() {
		this.loading = false;
		this.$nextTick(() => {
			this.$refs.username.focus();
		});
	},

	methods: {
		loginAdmin: async function() {
			this.error_msg = "";

			if (this.username.length == "") {
				this.error_msg = "Insira a credencial do usuário.";
				this.$refs.username.focus();
				return;
			}

			if (this.password.length == "") {
				this.error_msg = "Insira uma senha.";
				this.$refs.username.focus();
				return;
			}

			let post = {
				username: this.username, 
				password: this.password
			};
			
			let result = null;
			this.loading = true;
			try {
				result = await Api.post("auth/login", post, "admin");
			} catch(ex) {
				console.log(ex);
			}

			// Verifica se foi retornado
			if (result) {
				// Verifica o resultado da requisição
				if (result.error) {
					this.loginUser(post);
				} else {
					this.$api.user = result.data;
					window.localStorage.setItem('sessid', this.$api.user.sessid);
					this.loading = false;
					this.$emit("logged");
				}
			} else {
				this.loginUser(post);
			}
		},

		loginUser: async function(post) {
			let result = null;
			try {
				result = await Api.post("auth/login", post);
			} catch(ex) {
				console.log(ex);
			}

			if (result) {
				if (result.error) {
					this.error_msg = result.data;
					this.loading = false;
					return;
				} else {
					this.$api.user = result.data;
					window.localStorage.setItem('sessid', this.$api.user.sessid);
					this.loading = false;
					this.$emit("logged");
				}
			} else {
				this.error_msg = "Não possível fazer o login.";
				return;
			}
		},

		forgotPassword: function() {
			this.$emit("next", this.username);
		},
	}
}
</script>

<style scoped>
.login-wrapper {
	width: 100vw;
	height: 100vh;
	background: #222;
}

.login-logo {
	height: 30px;
	margin: 15px auto;
	display: block;
	margin-bottom: 25px;
}

.login-form	{
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	margin: auto;
	width: 400px;
	height: 395px;
	background: #333;
	padding: 25px;
	border-radius: 4px;
}

.login-input-wrapper {
	position: relative;
	width: 100%;
}

.login-input {
	width: 100%;
	height: 40px;
	padding-left: 40px;
	border: none;
	margin-bottom: 25px;
	font-weight: bold;
	color: #222;
}

.login-input-icon {
	position: absolute;
	width: 40px;
	height: 40px;
	left: 0;
	line-height: 40px;
	color: #222;
}

.login-forgot-password-wrapper {
	margin-bottom: 25px;
	text-align: right;
}

.login-forgot-password-wrapper > a {
	font-size: 12px;
	text-decoration: none;
	color: #fff;
}

.login-error-wrapper {
	min-height: 38px;
	margin: 20px 0px;
	text-align: center;
}

.login-error-wrapper > .login-error {
	color: #fff;
	font-size: 14px;
	font-weight: bold;
}

.login-submit {
	width: 100%;
	height: 40px;
	border: none;
	background: #fff;
	font-weight: bold;
}

.password-input-button {
	position: absolute;
	width: 40px;
	right: 0;
	line-height: 40px;
	color: #222;
	background: #fff;
	border: none;
}
</style>